<template>
    <div class="mx-auto container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Seating Arrangement Report</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>

            <v-row justify="center" dense>
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="exam_plan" item-value="id"
                        :items="exam_plan_list" item-text="exam_name" label="Exam Plan" outlined persistent-hint
                        hint="Please Select Exam Plan" @change="getExamPlanData()" />
                </v-col>

                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded multiple chips clearable v-model="conduct_type"
                        item-value="id" :items="conduct_type_list" item-text="conduct_type" label="Exam Conduct Type"
                        outlined persistent-hint hint="Please Select Exam Conduct Type"
                        @change="updateSelectAll('conduct_type')">
                        <template v-slot:prepend-item>
                            <v-list-item @click="toggleSelectAll('conduct_type')">
                                <v-list-item-action>
                                    <v-checkbox :input-value="selected_all_conduct_type"
                                        @click.stop="toggleSelectAll('conduct_type')"></v-checkbox>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>Select All</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                        </template>
                    </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded multiple chips clearable v-model="stream"
                        item-value="id" :items="stream_list" item-text="stream_name" label="Stream" outlined
                        persistent-hint hint="Please Select Stream">
                        <template v-slot:prepend-item>
                            <v-list-item @click="toggleSelectAll('stream')">
                                <v-list-item-action>
                                    <v-checkbox :input-value="selected_all_stream"
                                        @click.stop="toggleSelectAll('stream')"></v-checkbox>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>Select All</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                        </template>
                    </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="3" md="3" v-if="exam_plan">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded multiple chips clearable v-model="standard"
                        item-value="id" :items="standard_list" item-text="standard" label="Standard" outlined
                        persistent-hint hint="Please Select Standard" @change="standardChanged">
                        <template v-slot:prepend-item>
                            <v-list-item @click="toggleSelectAll('standard')">
                                <v-list-item-action>
                                    <v-checkbox :input-value="selected_all_standard"
                                        @click.stop="toggleSelectAll('standard')"></v-checkbox>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>Select All</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                        </template>
                    </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="3" md="3" v-if="standard.length">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded multiple chips clearable v-model="subject"
                        item-value="id" :items="course_list" item-text="course" label="Subject" outlined persistent-hint
                        hint="Please Select Subject" @change="updateSelectAll('subject')">
                        <template v-slot:prepend-item>
                            <v-list-item @click="toggleSelectAll('subject')">
                                <v-list-item-action>
                                    <v-checkbox :input-value="selected_all_subject"
                                        @click.stop="toggleSelectAll('subject')"></v-checkbox>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>Select All</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                        </template>
                    </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded multiple chips clearable v-model="room"
                        item-value="id" :items="room_list" item-text="room_no" label="Room" outlined persistent-hint
                        hint="Please Select Room" @change="updateSelectAll('room')">
                        <template v-slot:prepend-item>
                            <v-list-item @click="toggleSelectAll('room')">
                                <v-list-item-action>
                                    <v-checkbox :input-value="selected_all_room"
                                        @click.stop="toggleSelectAll('room')"></v-checkbox>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>Select All</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                        </template>
                    </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="3" md="3" v-if="standard.length">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded multiple chips clearable v-model="student"
                        item-value="id" :items="student_list" item-text="student_name" label="Student" outlined
                        persistent-hint hint="Please Select Student" @change="updateSelectAll('student')">

                        <template v-slot:selection="{ item, index }">
                            <v-chip v-if="index < 2" small>
                                {{ item.student_name }}
                            </v-chip>

                            <span v-else-if="index === 2" class="grey--text text-caption ml-1">
                                + {{ student.length - 2 }} more
                            </span>
                        </template>

                        <template v-slot:prepend-item>
                            <v-list-item @click="toggleSelectAll('student')">
                                <v-list-item-action>
                                    <v-checkbox :input-value="selected_all_student"
                                        @click.stop="toggleSelectAll('student')">
                                    </v-checkbox>
                                </v-list-item-action>

                                <v-list-item-content>
                                    <v-list-item-title>Select All</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>

                            <v-divider></v-divider>
                        </template>
                    </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded multiple chips clearable v-model="supervisor"
                        item-value="id" :items="supervisor_list" item-text="employee_name" label="Supervisor" outlined
                        persistent-hint hint="Please Select Supervisor" @change="updateSelectAll('supervisor')">

                        <template v-slot:selection="{ item, index }">
                            <v-chip v-if="index < 2" small>
                                {{ item.employee_name }}
                            </v-chip>

                            <span v-else-if="index === 2" class="grey--text text-caption ml-1">
                                + {{ supervisor.length - 2 }} more
                            </span>
                        </template>

                        <template v-slot:prepend-item>
                            <v-list-item @click="toggleSelectAll('supervisor')">
                                <v-list-item-action>
                                    <v-checkbox :input-value="selected_all_supervisor"
                                        @click.stop="toggleSelectAll('supervisor')">
                                    </v-checkbox>
                                </v-list-item-action>

                                <v-list-item-content>
                                    <v-list-item-title>Select All</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>

                            <v-divider></v-divider>
                        </template>
                    </v-autocomplete>
                </v-col>
            </v-row>
            <v-row class="mt-2 mb-2" justify="center" align="center">
                <v-col cols="12" class="d-flex justify-center align-center">
                    <v-btn color="info" small class="mr-2" @click="getSeatingArrangementReport">
                        <v-icon small class="mr-1">mdi-magnify</v-icon>
                        Fetch
                    </v-btn>

                    <v-btn color="primary" small @click="openSeatingArrangementDialog">
                        <v-icon small class="mr-1">mdi-plus</v-icon>
                        Add Seating Arrangement
                    </v-btn>

                    <v-btn color="success" small class="ml-2" @click="exportExcel"
                        :disabled="!seating_arrangement_list.length">
                        <v-icon small class="mr-1">mdi-file-excel</v-icon>
                        Export Excel
                    </v-btn>

                    <v-btn color="error" small class="ml-2" @click="exportPDF"
                        :disabled="!seating_arrangement_list.length">
                        <v-icon small class="mr-1">mdi-file-pdf-box</v-icon>
                        Export PDF
                    </v-btn>
                </v-col>
            </v-row>
            <v-data-table :headers="seating_arrangement_headers" :items="seating_arrangement_list"
                class="elevation-1 mytable" dense :loading="overlay" v-if="exam_plan" :items-per-page="25"
                :footer-props="{
                    'items-per-page-options': [10, 25, 50, 100]
                }">

                <template v-slot:item.subject_name="{ item }">
                    {{ item.subject_code }} - {{ item.subject_name }}
                </template>

                <template v-slot:item.is_absent="{ item }">
                    <v-chip x-small :color="item.is_absent ? 'red' : 'green'" dark>
                        {{ item.is_absent ? 'Yes' : 'No' }}
                    </v-chip>
                </template>

                <template v-slot:item.actions="{ item }">
                    <v-btn icon small @click="editSeatingArrangement(item)">
                        <v-icon small color="primary">mdi-pencil</v-icon>
                    </v-btn>

                    <v-btn icon small @click="deleteSeatingArrangement(item)">
                        <v-icon small color="red">mdi-delete</v-icon>
                    </v-btn>
                </template>

                <template v-slot:no-data>
                    No Seating Arrangement found.
                </template>
            </v-data-table>
            <v-dialog v-model="seating_arrangement_dialog" max-width="1100px" persistent>
                <v-card>
                    <v-toolbar dense flat color="white" class="toolbar">
                        <v-toolbar-title>
                            {{ seating_form.id ? 'Edit Seating Arrangement' : 'Add Seating Arrangement' }}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="closeSeatingArrangementDialog">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>

                    <v-divider></v-divider>

                    <v-card-text>
                        <v-row dense>


                            <!-- Exam Plan -->
                            <v-col cols="12" sm="4" class="mt-3">
                                <v-autocomplete v-model="seating_form.exam_plan" :items="exam_plan_list" item-value="id"
                                    item-text="exam_name" label="Exam Plan" outlined dense rounded
                                    :readonly="!!seating_form.id" :filled="!!seating_form.id" @change="examPlanChanged">
                                </v-autocomplete>
                            </v-col>

                            <!-- Exam Conduct Type -->
                            <v-col cols="12" sm="4" class="mt-3">
                                <v-autocomplete v-model="seating_form.conduct_type" :items="seating_conduct_type_list"
                                    item-value="id" item-text="conduct_type" label="Exam Conduct Type" outlined dense
                                    :readonly="!!seating_form.id" :filled="!!seating_form.id" rounded
                                    @change="seatingSelectionChanged">
                                </v-autocomplete>
                            </v-col>

                            <!-- Stream -->
                            <v-col cols="12" sm="4" class="mt-3">
                                <v-autocomplete v-model="seating_form.stream" :items="seating_stream_list"
                                    item-value="id" item-text="stream_name" label="Stream" outlined dense rounded
                                    :readonly="!!seating_form.id" :filled="!!seating_form.id"
                                    @change="seatingSelectionChanged">
                                </v-autocomplete>
                            </v-col>

                            <!-- Standard -->
                            <v-col cols="12" sm="4">
                                <v-autocomplete v-model="seating_form.standard" :items="seating_standard_list"
                                    item-value="id" item-text="standard" label="Standard" outlined dense rounded
                                    :readonly="!!seating_form.id" :filled="!!seating_form.id"
                                    @change="seatingSelectionChanged">
                                </v-autocomplete>
                            </v-col>

                            <!-- Subject -->
                            <v-col cols="12" sm="4">
                                <v-autocomplete v-model="seating_form.subject" :items="seating_subject_list"
                                    item-value="id" item-text="course" label="Subject" outlined dense rounded
                                    :readonly="!!seating_form.id" :filled="!!seating_form.id"
                                    @change="getSeatingStudents">
                                </v-autocomplete>
                            </v-col>

                            <!-- Student -->
                            <v-col cols="12" sm="4">
                                <v-autocomplete v-model="seating_form.student" :items="seating_student_list"
                                    :readonly="!!seating_form.id" :filled="!!seating_form.id" item-value="id"
                                    item-text="student_name" label="Student" outlined dense rounded>
                                </v-autocomplete>
                            </v-col>

                            <!-- Exam Date -->
                            <v-col cols="12" sm="4">
                                <v-autocomplete v-model="seating_form.exam_date" :items="seating_exam_date_list"
                                    :readonly="!!seating_form.id" :filled="!!seating_form.id" item-value="date"
                                    item-text="display_date" label="Exam Date" outlined dense rounded
                                    @change="examDateChanged">
                                </v-autocomplete>
                            </v-col>

                            <!-- Exam Day -->
                            <v-col cols="12" sm="4">
                                <v-text-field v-model="seating_form.exam_day" label="Exam Day" outlined dense rounded
                                    :filled="!!seating_form.id" readonly>
                                </v-text-field>
                            </v-col>

                            <!-- Slot -->
                            <v-col cols="12" sm="4">
                                <v-select v-model="seating_form.slot" :items="seating_slot_list" item-value="id"
                                    :readonly="!!seating_form.id" :filled="!!seating_form.id" item-text="slot_display"
                                    label="Slot Number" outlined dense rounded>
                                </v-select>
                            </v-col>

                            <!-- Room -->
                            <v-col cols="12" sm="4">
                                <v-autocomplete v-model="seating_form.room" :items="seating_room_list" item-value="id"
                                    item-text="room_no" label="Room" outlined dense rounded @change="roomChanged">
                                </v-autocomplete>
                            </v-col>

                            <!-- Bench Number -->
                            <v-col cols="12" sm="4">
                                <v-autocomplete v-model="seating_form.bench_number" :items="bench_number_list"
                                    label="Bench Number" outlined dense rounded>
                                </v-autocomplete>
                            </v-col>

                            <!-- Bench Side -->
                            <v-col cols="12" sm="4">
                                <v-autocomplete v-model="seating_form.bench_side" :items="seating_bench_side_list"
                                    item-value="id" item-text="name" label="Bench Side" outlined dense rounded>
                                </v-autocomplete>
                            </v-col>

                            <!-- Is Absent -->
                            <v-col cols="12" sm="4" class="d-flex align-center">
                                <v-checkbox v-model="seating_form.is_absent" label="Is Absent" class="mt-0">
                                </v-checkbox>
                            </v-col>

                        </v-row>

                        <v-row justify="center" class="mt-2">
                            <v-btn color="primary" small @click="saveSeatingArrangement">
                                {{ seating_form.id ? 'Update' : 'Save' }}
                            </v-btn>

                            <v-btn text small class="ml-2" @click="closeSeatingArrangementDialog">
                                Cancel
                            </v-btn>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";

export default {
    data: () => ({
        valid: false,
        overlay: false,
        loader: false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        search: "",
        dialog: false,
        exam_plan: "",
        conduct_type: [],
        stream: [],
        standard: [],
        subject: [],
        room: [],
        student: [],
        supervisor: [],
        org_basic_data: [],
        present: false,
        absent: false,
        seating_arrangement_headers: [
            { text: "Sr. No.", value: "sr_no" },
            { text: "Exam Date", value: "exam_date" },
            { text: "Day", value: "exam_day" },
            { text: "Slot", value: "slot_number" },
            { text: "Time", value: "time" },
            { text: "Subject Code", value: "subject_code" },
            { text: "Subject", value: "subject_name" },
            { text: "Standard", value: "standard" },
            { text: "Division", value: "division" },
            { text: "Stream", value: "stream" },
            { text: "Roll No", value: "rollno" },
            { text: "Student", value: "student_name" },
            { text: "Room", value: "room_no" },
            { text: "Bench", value: "bench_number" },
            { text: "Bench Side", value: "bench_side" },
            { text: "Supervisor", value: "supervisor" },
            { text: "Absent", value: "is_absent" },
            { text: "Generated By", value: "generatedby" },
            { text: "Actions", value: "actions", sortable: false }
        ],
        seating_arrangement_list: [],
        exam_plan_list: [],
        room_list: [],
        conduct_type_list: [],
        stream_list: [],
        standard_list: [],
        course_list: [],
        student_list: [],
        supervisor_list: [],
        attendance_report: [],
        editedIndex: -1,
        selected_all_stream: false,
        selected_all_standard: false,
        selected_all_subject: false,
        selected_all_room: false,
        selected_all_student: false,
        selected_all_supervisor: false,
        selected_all_conduct_type: false,
        academic_year: "",
        semester: "",
        conduct_type: "",
        exam_date: "",
        exam_slot: "",
        subject: "",
        room: "",
        bench_side: "",
        exam_date_list: [],
        exam_slot_list: [],
        subject_list: [],
        room_list: [],
        bench_side_list: [],
        seating_arrangement_list: [],
        seating_arrangement_dialog: false,

        seating_form: {
            exam_plan: "",
            conduct_type: "",
            stream: "",
            standard: "",
            subject: "",
            student: "",
            exam_date: "",
            exam_day: "",
            slot: "",
            room: "",
            bench_number: "",
            bench_side: "",
            is_absent: false
        },

        seating_conduct_type_list: [],
        seating_stream_list: [],
        seating_standard_list: [],
        seating_subject_list: [],
        seating_student_list: [],
        seating_exam_date_list: [],
        seating_slot_list: [],
        seating_room_list: [],
        seating_bench_side_list: [],
        bench_number_list: []
    }),

    watch: {
        dialog(val) {
            val || this.close();
        }
    },

    mounted() {
        this.onLoad();
    },

    methods: {
        async editSeatingArrangement(item) {
            console.log("EDIT SEATING ITEM =", item);

            this.seating_form = {
                id: item.id,
                exam_plan: item.exam_plan_id,
                conduct_type: item.conduct_type_id,
                stream: item.stream_id,
                standard: item.standard_id,
                subject: "",
                student: "",
                exam_date: "",
                exam_day: "",
                slot: "",
                room: item.room_id,
                bench_number: item.bench_number,
                bench_side: item.bench_side_id || "",
                is_absent: item.is_absent || false
            };

            this.seating_arrangement_dialog = true;

            this.seating_conduct_type_list = [];
            this.seating_stream_list = [];
            this.seating_standard_list = [];
            this.seating_subject_list = [];
            this.seating_student_list = [];
            this.seating_exam_date_list = [];
            this.seating_slot_list = [];
            this.seating_room_list = [];
            this.seating_bench_side_list = [];
            this.bench_number_list = [];

            await this.getSeatingArrangementData();

            this.seating_form.conduct_type = item.conduct_type_id;
            this.seating_form.stream = item.stream_id;
            this.seating_form.standard = item.standard_id;

            await this.getSeatingSubjects();
            this.seating_form.subject = item.subject_id;

            await this.getSeatingStudents();
            this.seating_form.student = item.student_id;

            console.log("EDIT DATE FROM REPORT =", item.exam_date_value);
            console.log("AVAILABLE DATES =", this.seating_exam_date_list);

            const selectedExamDate = this.seating_exam_date_list.find(
                x => String(x.date) === String(item.exam_date_value)
            );

            if (selectedExamDate) {
                this.seating_form.exam_date = selectedExamDate.date;
                this.seating_form.exam_day = selectedExamDate.day;
            } else {
                this.seating_form.exam_date = item.exam_date_value;
                this.seating_form.exam_day = "";
            }

            console.log("SELECTED EDIT DATE =", this.seating_form.exam_date);
            console.log("SELECTED EDIT DAY =", this.seating_form.exam_day);

            await this.getSeatingSlots();

            console.log("EDIT SLOT LIST =", this.seating_slot_list);
            console.log("EDIT SLOT ID =", item.slot_id);

            const selectedSlot = this.seating_slot_list.find(
                x => String(x.id) === String(item.slot_id)
            );

            this.seating_form.slot = selectedSlot
                ? selectedSlot.id
                : item.slot_id;

            this.seating_form.room = item.room_id;

            this.roomChanged();

            this.seating_form.bench_number = item.bench_number;
            this.seating_form.bench_side = item.bench_side_id || "";
            this.seating_form.is_absent = item.is_absent || false;

            console.log("FINAL EDIT FORM =", this.seating_form);
        },
        getSeatingArrangementReport() {
            if (!this.exam_plan) {
                this.seating_arrangement_list = [];
                return;
            }

            const data = {
                exam_plan: this.exam_plan,
                conduct_type: this.conduct_type,
                stream: this.stream,
                standard: this.standard,
                subject: this.subject,
                room: this.room,
                student: this.student,
                supervisor: this.supervisor
            };

            this.overlay = true;

            axios.post("/SeatingArrangement/getSeatingArrangementReportData", data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.seating_arrangement_list = res.data.seating_arrangement_list || [];
                        this.org_basic_data = res.data.org_basic_data || [];


                        this.seating_arrangement_list =
                            this.seating_arrangement_list.map((item, index) => {
                                item.sr_no = index + 1;
                                return item;
                            });
                    } else {
                        this.seating_arrangement_list = [];
                        this.showSnackbar(
                            "#b71c1c",
                            res.data.text || "Unable to fetch Seating Arrangement."
                        );
                    }
                })
                .catch((error) => {
                    this.seating_arrangement_list = [];
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        examPlanChanged() {
            this.seating_form.conduct_type = "";
            this.seating_form.stream = "";
            this.seating_form.standard = "";
            this.seating_form.subject = "";
            this.seating_form.student = "";
            this.seating_form.exam_date = "";
            this.seating_form.exam_day = "";
            this.seating_form.slot = "";
            this.seating_form.room = "";
            this.seating_form.bench_number = "";
            this.seating_form.bench_side = "";
            this.seating_form.is_absent = false;

            this.seating_conduct_type_list = [];
            this.seating_stream_list = [];
            this.seating_standard_list = [];
            this.seating_subject_list = [];
            this.seating_student_list = [];
            this.seating_exam_date_list = [];
            this.seating_slot_list = [];
            this.seating_room_list = [];
            this.seating_bench_side_list = [];
            this.bench_number_list = [];

            if (!this.seating_form.exam_plan) {
                return;
            }

            this.getSeatingArrangementData();
        },
        openSeatingArrangementDialog() {
            if (!this.exam_plan) {
                this.showSnackbar("#b71c1c", "Please Select Exam Plan");
                return;
            }

            this.seating_form = {
                exam_plan: this.exam_plan,
                conduct_type: "",
                stream: "",
                standard: "",
                subject: "",
                student: "",
                exam_date: "",
                exam_day: "",
                slot: "",
                room: "",
                bench_number: "",
                bench_side: "",
                is_absent: false
            };

            this.seating_conduct_type_list = [];
            this.seating_stream_list = [];
            this.seating_standard_list = [];
            this.seating_subject_list = [];
            this.seating_student_list = [];
            this.seating_exam_date_list = [];
            this.seating_slot_list = [];
            this.seating_room_list = [];
            this.seating_bench_side_list = [];
            this.bench_number_list = [];

            this.seating_arrangement_dialog = true;

            this.getSeatingArrangementData();
        },

        closeSeatingArrangementDialog() {
            this.seating_arrangement_dialog = false;
        },
        seatingSelectionChanged() {
            this.getSeatingSubjects();
        },
        getSeatingArrangementData() {
            if (!this.seating_form.exam_plan) {
                return Promise.resolve();
            }

            const data = {
                exam_plan: this.seating_form.exam_plan
            };

            console.log("SEATING ARRANGEMENT DATA =", data);

            this.overlay = true;

            return axios.post("/SeatingArrangement/getSeatingArrangementData", data)
                .then((res) => {
                    console.log("SEATING ARRANGEMENT RESPONSE =", res.data);

                    if (res.data.msg == "200") {
                        this.seating_conduct_type_list = res.data.conduct_type_list || [];
                        this.seating_stream_list = res.data.stream_list || [];
                        this.seating_standard_list = res.data.standard_list || [];
                        this.seating_exam_date_list = res.data.exam_date_list || [];
                        this.seating_room_list = res.data.room_list || [];
                        this.seating_bench_side_list = res.data.bench_side_list || [];
                    }
                })
                .catch((error) => {
                    console.log("SEATING ARRANGEMENT ERROR =", error);
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        examDateChanged() {
            const selectedDate = this.seating_exam_date_list.find(
                x => String(x.date) === String(this.seating_form.exam_date)
            );

            this.seating_form.exam_day = selectedDate
                ? selectedDate.day
                : "";

            this.seating_slot_list = [];
            this.seating_form.slot = "";

            this.getSeatingSlots();
        },
        getSeatingSlots() {
            if (!this.seating_form.exam_plan || !this.seating_form.exam_date) {
                return;
            }

            const data = {
                exam_plan: this.seating_form.exam_plan,
                exam_date: this.seating_form.exam_date
            };

            this.overlay = true;

            return axios.post("/SeatingArrangement/getSeatingSlots", data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.seating_slot_list = res.data.slot_list || [];
                    } else {
                        this.seating_slot_list = [];
                    }
                })
                .catch((error) => {
                    this.seating_slot_list = [];
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        getSeatingSubjects() {
            this.seating_form.subject = "";
            this.seating_subject_list = [];
            this.seating_form.student = "";
            this.seating_student_list = [];

            if (!this.seating_form.exam_plan ||
                !this.seating_form.conduct_type ||
                !this.seating_form.stream ||
                !this.seating_form.standard) {
                return;
            }

            const data = {
                exam_plan: this.seating_form.exam_plan,
                conduct_type: this.seating_form.conduct_type,
                stream: this.seating_form.stream,
                standard: this.seating_form.standard
            };

            this.overlay = true;

            return axios.post("/SeatingArrangement/getSeatingSubjects", data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.seating_subject_list =
                            res.data.subject_list || [];
                    } else {
                        this.seating_subject_list = [];
                    }
                })
                .catch((error) => {
                    this.seating_subject_list = [];
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        getSeatingStudents() {
            this.seating_form.student = "";
            this.seating_student_list = [];

            if (!this.seating_form.exam_plan ||
                !this.seating_form.standard ||
                !this.seating_form.subject) {
                return;
            }

            const data = {
                exam_plan: this.seating_form.exam_plan,
                std: [this.seating_form.standard]
            };

            this.overlay = true;

            return axios.post("/SeatingArrangement/getStudentsByStandards", data)
                .then((res) => {

                    if (res.data.msg == "200") {
                        this.seating_student_list =
                            res.data.students_list || [];
                    } else {
                        this.seating_student_list = [];
                    }
                })
                .catch((error) => {
                    this.seating_student_list = [];
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        roomChanged() {
            this.bench_number_list = [];
            this.seating_form.bench_number = "";

            const room = this.seating_room_list.find(
                x => String(x.id) === String(this.seating_form.room)
            );

            if (!room) {
                return;
            }

            const numberOfBenches = Number(room.number_of_benches || 0);

            for (let i = 1; i <= numberOfBenches; i++) {
                this.bench_number_list.push(i);
            }
        },
        saveSeatingArrangement() {
            if (!this.seating_form.exam_plan) {
                this.showSnackbar("#b71c1c", "Please Select Exam Plan");
                return;
            }

            if (!this.seating_form.conduct_type) {
                this.showSnackbar("#b71c1c", "Please Select Exam Conduct Type");
                return;
            }

            if (!this.seating_form.stream) {
                this.showSnackbar("#b71c1c", "Please Select Stream");
                return;
            }

            if (!this.seating_form.standard) {
                this.showSnackbar("#b71c1c", "Please Select Standard");
                return;
            }

            if (!this.seating_form.subject) {
                this.showSnackbar("#b71c1c", "Please Select Subject");
                return;
            }

            if (!this.seating_form.student) {
                this.showSnackbar("#b71c1c", "Please Select Student");
                return;
            }

            if (!this.seating_form.exam_date) {
                this.showSnackbar("#b71c1c", "Please Select Exam Date");
                return;
            }

            if (!this.seating_form.slot) {
                this.showSnackbar("#b71c1c", "Please Select Slot");
                return;
            }

            if (!this.seating_form.room) {
                this.showSnackbar("#b71c1c", "Please Select Room");
                return;
            }

            if (!this.seating_form.bench_number) {
                this.showSnackbar("#b71c1c", "Please Select Bench Number");
                return;
            }

            const data = {
                id: this.seating_form.id || null,
                exam_plan: this.seating_form.exam_plan,
                conduct_type: this.seating_form.conduct_type,
                stream: this.seating_form.stream,
                standard: this.seating_form.standard,
                subject: this.seating_form.subject,
                student: this.seating_form.student,
                exam_date: this.seating_form.exam_date,
                exam_day: this.seating_form.exam_day,
                slot: this.seating_form.slot,
                room: this.seating_form.room,
                bench_number: this.seating_form.bench_number,
                bench_side: this.seating_form.bench_side,
                is_absent: this.seating_form.is_absent
            };

            const url = this.seating_form.id
                ? "/SeatingArrangement/updateSeatingArrangement"
                : "/SeatingArrangement/saveSeatingArrangement";


            this.overlay = true;

            axios.post(url, data)
                .then((res) => {

                    if (res.data.msg == "200") {
                        this.showSnackbar(
                            "#388E3C",
                            res.data.text || "Seating Arrangement saved successfully."
                        );

                        this.closeSeatingArrangementDialog();
                        this.getSeatingArrangementReport();
                    } else {
                        this.showSnackbar(
                            "#b71c1c",
                            res.data.text || "Unable to save Seating Arrangement."
                        );
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        deleteSeatingArrangement(item) {
            if (!confirm("Are you sure you want to delete this Seating Arrangement?")) {
                return;
            }

            const data = {
                id: item.id
            };

            this.overlay = true;

            axios.post("/SeatingArrangement/deleteSeatingArrangement", data)
                .then((res) => {

                    if (res.data.msg == "200") {
                        this.showSnackbar(
                            "#388E3C",
                            res.data.text || "Seating Arrangement deleted successfully."
                        );

                        this.getSeatingArrangementReport();
                    } else {
                        this.showSnackbar(
                            "#b71c1c",
                            res.data.text || "Unable to delete Seating Arrangement."
                        );
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        toggleSelectAll(type) {
            const listMap = {
                conduct_type: "conduct_type_list",
                stream: "stream_list",
                standard: "standard_list",
                subject: "course_list",
                room: "room_list",
                student: "student_list",
                supervisor: "supervisor_list"
            };

            const selectedMap = {
                conduct_type: "selected_all_conduct_type",
                stream: "selected_all_stream",
                standard: "selected_all_standard",
                subject: "selected_all_subject",
                room: "selected_all_room",
                student: "selected_all_student",
                supervisor: "selected_all_supervisor"
            };

            const valueMap = {
                conduct_type: "conduct_type",
                stream: "stream",
                standard: "standard",
                subject: "subject",
                room: "room",
                student: "student",
                supervisor: "supervisor"
            };

            const items = this[listMap[type]] || [];
            const values = items.map(x => x.id);

            if (this[selectedMap[type]]) {
                this[selectedMap[type]] = false;
                this[valueMap[type]] = [];
            } else {
                this[selectedMap[type]] = true;
                this[valueMap[type]] = [...values];
            }

            if (type === "standard") {
                this.subject = [];
                this.student = [];
                this.selected_all_subject = false;
                this.selected_all_student = false;
                this.coursewiseStandardChanged();
                this.getStudents();
            }
        },
        updateSelectAll(type) {
            const listMap = {
                conduct_type: "conduct_type_list",
                stream: "stream_list",
                standard: "standard_list",
                subject: "course_list",
                room: "room_list",
                student: "student_list",
                supervisor: "supervisor_list"
            };

            const selectedMap = {
                conduct_type: "selected_all_conduct_type",
                stream: "selected_all_stream",
                standard: "selected_all_standard",
                subject: "selected_all_subject",
                room: "selected_all_room",
                student: "selected_all_student",
                supervisor: "selected_all_supervisor"
            };

            const valueMap = {
                conduct_type: "conduct_type",
                stream: "stream",
                standard: "standard",
                subject: "subject",
                room: "room",
                student: "student",
                supervisor: "supervisor"
            };

            const items = this[listMap[type]] || [];
            const selected = this[valueMap[type]] || [];

            this[selectedMap[type]] =
                items.length > 0 && selected.length === items.length;
        },
        onLoad() {
            this.overlay = true;
            axios.post("/SeatingArrangement/getData")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.exam_plan_list = res.data.exam_plan_list || [];
                        this.room_list = res.data.room_list || [];
                        this.supervisor_list = res.data.supervisor_list || [];

                        const savedExamPlan = localStorage.getItem("exam_plan");

                        if (savedExamPlan) {
                            const examPlanExists = this.exam_plan_list.some(
                                x => String(x.id) === String(savedExamPlan)
                            );

                            if (examPlanExists) {
                                this.exam_plan = Number(savedExamPlan);
                                this.getExamPlanData();
                            }
                        }
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        getExamPlanData() {
            this.seating_arrangement_list = [];
            this.conduct_type = [];
            this.stream = [];
            this.standard = [];
            this.subject = [];
            this.student = [];
            this.room = [];
            this.supervisor = [];

            this.selected_all_conduct_type = false;
            this.selected_all_stream = false;
            this.selected_all_standard = false;
            this.selected_all_subject = false;
            this.selected_all_room = false;
            this.selected_all_student = false;
            this.selected_all_supervisor = false;


            this.conduct_type_list = [];
            this.stream_list = [];
            this.standard_list = [];
            this.course_list = [];
            this.student_list = [];

            if (!this.exam_plan) {
                return;
            }

            const data = {
                exam_plan: this.exam_plan
            };

            this.overlay = true;

            axios.post("/SeatingArrangement/getDataOnExamPlan", data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.conduct_type_list = res.data.conduct_type_list || [];
                        this.stream_list = res.data.stream_list || [];
                        this.standard_list = res.data.standard_list || [];

                        if (this.conduct_type_list.length > 0) {
                            this.conduct_type = this.conduct_type_list.map(x => x.id);
                            this.selected_all_conduct_type = true;
                        }
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        standardChanged() {
            this.updateSelectAll("standard");
            this.getStudents();
            this.coursewiseStandardChanged();
        },
        async coursewiseStandardChanged() {
            this.subject = [];
            this.course_list = [];
            this.selected_all_subject = false;

            if (!this.standard || !this.standard.length) {
                return;
            }

            const data = {
                standard: this.standard
            };

            this.overlay = true;

            try {
                const res = await axios.post("/BookReview/getCourseOfferingsBystd", data);

                if (res.data.msg == "200") {
                    this.course_list = (res.data.course_list || []).filter(
                        x => x.id != null
                    );
                } else {
                    this.course_list = [];
                }
            } catch (error) {
                this.course_list = [];
                this.showSnackbar("#b71c1c", "Something went wrong!!!");
            } finally {
                this.overlay = false;
            }
        },
        getStudents() {
            this.student = [];
            this.student_list = [];
            this.selected_all_student = false;

            if (!this.exam_plan || !this.standard || !this.standard.length) {
                return;
            }

            const data = {
                exam_plan: this.exam_plan,
                std: this.standard
            };

            this.overlay = true;

            axios.post("/SeatingArrangement/getStudentsByStandards", data)
                .then((res) => {

                    if (res.data.msg == "200") {
                        this.student_list = res.data.students_list || [];
                    } else {
                        this.student_list = [];
                    }
                })
                .catch((error) => {
                    this.student_list = [];
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        close() {
            this.dialog = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },

        exportExcel() {

            if (!this.seating_arrangement_list.length) {
                this.showSnackbar("#b71c1c", "No data available to export.");
                return;
            }

            const excelData = this.seating_arrangement_list.map((item, index) => ({
                "Sr. No.": index + 1,
                "Exam Date": item.exam_date,
                "Day": item.exam_day,
                "Slot": item.slot_number,
                "Time": item.time,
                "Subject Code": item.subject_code,
                "Subject": item.subject_name,
                "Standard": item.standard,
                "Division": item.division,
                "Stream": item.stream,
                "Roll No": item.rollno,
                "Student": item.student_name,
                "Room": item.room_no,
                "Bench": item.bench_number,
                "Bench Side": item.bench_side,
                "Supervisor": item.supervisor,
                "Absent": item.is_absent ? "Yes" : "No",
                "Generated By": item.generatedby
            }));

            const worksheet = XLSX.utils.json_to_sheet(excelData);

            const workbook = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(
                workbook,
                worksheet,
                "Seating Arrangement"
            );

            XLSX.writeFile(
                workbook,
                "SeatingArrangementReport.xlsx"
            );
        },

        exportPDF() {
            if (!this.seating_arrangement_list.length) {
                this.showSnackbar("#b71c1c", "No data available to export");
                return;
            }
            const org = this.org_basic_data || [];

            const escapeHtml = (value) => {
                return String(value == null ? "" : value)
                    .replace(/&/g, "&amp;")
                    .replace(/</g, "&lt;")
                    .replace(/>/g, "&gt;")
                    .replace(/"/g, "&quot;")
                    .replace(/'/g, "&#39;");
            };

            const schoolName = escapeHtml(org.school_name || "");
            const trustName = escapeHtml(org.trust_name || "");
            const schoolLogo = org.school_logo || "";
            const trustLogo = org.trust_logo || "";

            const printWindow = window.open("", "_blank");

            let html = `
                <html>
                <head>
                    <title>Seating Arrangement Report</title>
                    <style>
                        @page {
                            size: A4 landscape;
                            margin: 10mm;
                        }

                        body {
                            font-family: Arial, sans-serif;
                            // font-size: 9px;
                        }

                        h2 {
                            text-align: center;
                            margin: 0 0 10px 0;
                            font-size: 16px;
                        }

                        table {
                            width: 100%;
                            border-collapse: collapse;
                        }

                        th, td {
                            border: 1px solid #000;
                            padding: 3px;
                            text-align: left;
                            font-size: 12px;
                        }

                        th {
                            font-weight: bold;
                        }

                        tr {
                            page-break-inside: avoid;
                        }
                        .report-header {
                            display: table;
                            width: 100%;
                            table-layout: fixed;
                            text-align: center;
                            margin-bottom: 10px;
                        }

                        .logo,
                        .school-details {
                            display: table-cell;
                            vertical-align: middle;
                        }

                        .logo {
                            width: 15%;
                        }

                        .logo img {
                            max-width: 85px;
                            max-height: 70px;
                            object-fit: contain;
                        }

                        .school-details {
                            width: 70%;
                        }

                        .trust-name {
                            font-size: 15px;
                            font-weight: bold;
                            margin-bottom: 5px;
                        }

                        .school-name {
                            font-size: 20px;
                            font-weight: bold;
                            text-transform: uppercase;
                            margin: 5px 0;
                        }

                        .report-title {
                            font-size: 16px;
                            font-weight: bold;
                            margin-top: 5px;
                        }
                    </style>
                </head>
                <body>
                <div style="
                    display:flex;
                    align-items:center;
                    justify-content:space-between;
                    width:100%;
                    box-sizing:border-box;
                    margin-bottom:40px;
                    margin-top:10px;
                ">

                    <img
                        src="${this.org_basic_data.trust_logo || ''}"
                        style="width:100px; height:90px; object-fit:contain; flex-shrink:0;"
                    />

                    <div style="flex:1; text-align:center; min-width:0;">
                        <h2>${this.org_basic_data.trust_name || ''}</h2>
                        <h2>${this.org_basic_data.school_name || ''}</h2>
                        <h2>Student Seating Arrangement Report</h2>
                    </div>

                    <img
                        src="${this.org_basic_data.school_logo || ''}"
                        style="width:100px; height:90px; object-fit:contain; flex-shrink:0;"
                    />

                </div>

                    <table>
                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                <th>Exam Date</th>
                                <th>Day</th>
                                <th>Slot</th>
                                <th>Time</th>
                                <th>Subject Code</th>
                                <th>Subject</th>
                                <th>Standard</th>
                                <th>Division</th>
                                <th>Stream</th>
                                <th>Roll No</th>
                                <th>Student</th>
                                <th>Room</th>
                                <th>Bench</th>
                                <th>Bench Side</th>
                                <th>Supervisor</th>
                                <th>Absent</th>
                                <th>Generated By</th>
                            </tr>
                        </thead>
                        <tbody>
            `;

            this.seating_arrangement_list.forEach((item, index) => {
                html += `
                    <tr>
                        <td>${index + 1}</td>
                        <td>${item.exam_date || ""}</td>
                        <td>${item.exam_day || ""}</td>
                        <td>${item.slot_number || ""}</td>
                        <td>${item.time || ""}</td>
                        <td>${item.subject_code || ""}</td>
                        <td>${item.subject_name || ""}</td>
                        <td>${item.standard || ""}</td>
                        <td>${item.division || ""}</td>
                        <td>${item.stream || ""}</td>
                        <td>${item.rollno || ""}</td>
                        <td>${item.student_name || ""}</td>
                        <td>${item.room_no || ""}</td>
                        <td>${item.bench_number || ""}</td>
                        <td>${item.bench_side || ""}</td>
                        <td>${item.supervisor || ""}</td>
                        <td>${item.is_absent ? "Yes" : "No"}</td>
                        <td>${item.generatedby || ""}</td>
                    </tr>
                `;
            });

            html += `
                        </tbody>
                    </table>
                </body>
                </html>
            `;

            
        printWindow.document.open();
        printWindow.document.write(html);
        printWindow.document.close();

        printWindow.onload = async () => {
            const images = Array.from(
                printWindow.document.querySelectorAll("img")
            );

            await Promise.all(
                images.map((img) => {
                    if (img.complete) {
                        return Promise.resolve();
                    }

                    return new Promise((resolve) => {
                        img.onload = resolve;
                        img.onerror = resolve;
                    });
                })
            );

    printWindow.focus();
    printWindow.print();
};

        }
    }
};
</script>

<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}
</style>